import { render, staticRenderFns } from "./change-requests.vue?vue&type=template&id=23a7cd9a&"
import script from "./change-requests.vue?vue&type=script&lang=js&"
export * from "./change-requests.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports